// extracted by mini-css-extract-plugin
export default {"chat-section-main":"ChatSection_chat-section-main__gbBBj","warning-text":"ChatSection_warning-text__kttX4"};